import { render, staticRenderFns } from "./KPointsList.vue?vue&type=template&id=0392e554&"
import script from "./KPointsList.vue?vue&type=script&lang=js&"
export * from "./KPointsList.vue?vue&type=script&lang=js&"
import style0 from "./KPointsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports